import React, { forwardRef } from 'react';

import { GatsbyImage, getImage } from 'gatsby-plugin-image';

// eslint-disable-next-line react/display-name
export const Image = forwardRef(({ src, className, alt = '', loading, ...props }, ref) => {
  const image = getImage(src);
  if (!image && src?.publicURL) {
    return <img ref={ref} className={className} src={src.publicURL} alt={alt} loading={loading} {...props} />;
  }
  return <GatsbyImage ref={ref} className={className} image={image} alt={alt} loading={loading} {...props} />;
});
